import React from 'react';
import PropTypes from 'prop-types';
import {filter, isEqual} from "lodash";

import StyledModal, { ModalActions } from '../Modal';
import Button from '../Button';
import * as Icons from '../icons/Icons';
import Tabs from '../TabsNew/Tabs';
import TabPanel from '../TabsNew/TabPanel';
import { FlexCol, FlexRow } from '../FlexGrid';
import SinglePhotoManager from "./SinglePhotoManager";
import Heading from '../Heading';
import {UPLOAD_MANAGER_SHAPE} from "./shapes";
import {scrollToY} from "../../../helpers/scrollToHelper";

export default class HeroImages extends React.Component {
    static propTypes = {
        primaryImage: PropTypes.any,
        gallery: PropTypes.array,
        uploadManager: UPLOAD_MANAGER_SHAPE,
        onHeroPublish: PropTypes.func,
        onHeroReload: PropTypes.func,
        onHeroDelete: PropTypes.func,
        onGalleryPublish: PropTypes.func,
        onGalleryReload: PropTypes.func,
        onGalleryDelete: PropTypes.func,
        inventoryType: PropTypes.string,
        offestTopVal: PropTypes.number
    };

    static defaultProps = {
        primaryImage: {},
        gallery: [],
        offestTopVal: 53,
    };

    constructor(props) {
        super(props);

        this.state = {
            isHelpModalOpen: false,
            showPrimaryImageUpload: false,
            showSecondary1ImageUpload: false,
            showSecondary2ImageUpload: false,
            primaryImagePreview: null,
            secondaryImage1Preview: null,
            secondaryImage2Preview: null,
            showFilesInput: false,
            currentTab: props.inventoryType === "gateway" ? 1 : 2
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps !== this.props) {
            if (isEqual(this.props.gallery, nextProps.gallery) &&
                isEqual(this.props.primaryImage, nextProps.primaryImage)) {
                return;
            }

            this.setState({
                primaryImagePreview: null,
                secondaryImage1Preview: null,
                secondaryImage2Preview: null,
            });
        }
    }

    getIsAltTextUnique = (input, id) => {
        const { gallery } = this.props;

        const galleryMinusThisOne = gallery.filter((item) => {
            return item.id !== id;
        });

        const index = galleryMinusThisOne.findIndex((item) => {
            return item.altText.trim().toUpperCase() === input.trim().toUpperCase();
        });

        if (index === -1) {
            return true;
        }

        return false;
    }

    editPrimaryImage = () => {
        this.setState({
            showPrimaryImageUpload: true,
            showSecondary1ImageUpload: false,
            showSecondary2ImageUpload: false,
            secondaryImage1Preview: null,
            secondaryImage2Preview: null,
            showFilesInput: false,
        },()=>{
            scrollToY(this._ref.offsetTop + this.props.offestTopVal);
        });
    }

    uploadPrimaryImage = () => {
        this.setState({
            showPrimaryImageUpload: true,
            showSecondary1ImageUpload: false,
            showSecondary2ImageUpload: false,
            secondaryImage1Preview: null,
            secondaryImage2Preview: null,
            showFilesInput: true,
        },()=>{
            scrollToY(this._ref.offsetTop + this.props.offestTopVal);
        });
    }

    editSecondaryImage1 = () => {
        this.setState({
            showPrimaryImageUpload: false,
            showSecondary1ImageUpload: true,
            showSecondary2ImageUpload: false,
            primaryImagePreview: null,
            secondaryImage2Preview: null,
            showFilesInput: false,
        },()=>{
            scrollToY(this._ref.offsetTop + this.props.offestTopVal);
        });
    }

    uploadSecondaryImage1 = () => {
        this.setState({
            showPrimaryImageUpload: false,
            showSecondary1ImageUpload: true,
            showSecondary2ImageUpload: false,
            primaryImagePreview: null,
            secondaryImage2Preview: null,
            showFilesInput: true,
        },()=>{
            scrollToY(this._ref.offsetTop + this.props.offestTopVal);
        });
    }

    editSecondaryImage2 = () => {
        this.setState({
            showPrimaryImageUpload: false,
            showSecondary1ImageUpload: false,
            showSecondary2ImageUpload: true,
            primaryImagePreview: null,
            secondaryImage1Preview: null,
            showFilesInput: false,
        },()=>{
            scrollToY(this._ref.offsetTop + this.props.offestTopVal);
        });
    }

    uploadSecondaryImage2 = () => {
        this.setState({
            showPrimaryImageUpload: false,
            showSecondary1ImageUpload: false,
            showSecondary2ImageUpload: true,
            primaryImagePreview: null,
            secondaryImage1Preview: null,
            showFilesInput: true,
        },()=>{
            scrollToY(this._ref.offsetTop + this.props.offestTopVal);
        });
    }

    toggleHelpModal = () => {
        this.setState({ isHelpModalOpen: !this.state.isHelpModalOpen });
    };

    onPrimaryImageUpdate = ({originalImage, croppedImage}) => {
        this.setState({
            primaryImagePreview: {
                originalImage,
                croppedImage
            }
        });
    }

    onPrimaryImageDelete = () => {
        this.setState({
            primaryImagePreview: null,
            showPrimaryImageUpload: false,
        }, () => {
            this.props.onHeroDelete()
        })
    }

    onPrimaryImagePublish = () => {
        this.setState({
            primaryImagePreview: null
        }, () => {
            this.props.onHeroPublish()
        })
    }

    onPrimaryImageCancelEditing = () => {
        this.setState({
            primaryImagePreview: null,
            showPrimaryImageUpload: false,
        }, () => {
            this.props.onHeroReload()
        })
    }

    onSecondaryImage1Update = ({originalImage, croppedImage}) => {
        this.setState({
            secondaryImage1Preview: {
                originalImage,
                croppedImage
            }
        });
    }

    onSecondaryImage1Delete = () => {
        this.setState({
            secondaryImage1Preview: null,
            showSecondary1ImageUpload: false,
        }, () => {
            this.props.onGalleryDelete()
        })
    }

    onSecondaryImage1Publish = () => {
        this.setState({
            secondaryImage1Preview: null
        }, () => {
            this.props.onGalleryPublish()
        })
    }

    onSecondaryImage1CancelEditing = () => {
        this.setState({
            secondaryImage1Preview: null,
            showSecondary1ImageUpload: false,
        }, () => {
            this.props.onGalleryReload()
        })
    }

    onSecondaryImage2Update = ({originalImage, croppedImage}) => {
        this.setState({
            secondaryImage2Preview: {
                originalImage,
                croppedImage
            }
        });
    }

    onSecondaryImage2Delete = () => {
        this.setState({
            secondaryImage2Preview: null,
            showSecondary2ImageUpload: false,
        }, () => {
            this.props.onGalleryDelete()
        })
    }

    onSecondaryImage2Publish = () => {
        this.setState({
            secondaryImage2Preview: null
        }, () => {
            this.props.onGalleryPublish()
        })
    }

    onSecondaryImage2CancelEditing = () => {
        this.setState({
            secondaryImage2Preview: null,
            showSecondary2ImageUpload: false,
        }, () => {
            this.props.onGalleryReload()
        })
    }

    handleChange = (index) => {
        this.setState({
            currentTab: index
        });
    }

    render() {
        const { isHelpModalOpen } = this.state;

        const { primaryImage, gallery } = this.props

        let galleryPhotos = [];
        if (gallery) {
            galleryPhotos = filter(gallery, { is_gallery: true });
        }

        let secondaryImage1 = {
            originalImage: {},
            croppedImage: {}
        };
        if (galleryPhotos?.length > 0) {
            const img = galleryPhotos[0];
            if (img !== primaryImage) {
                secondaryImage1 = img;
            }
        }

        let secondaryImage2 = {
            originalImage: {},
            croppedImage: {}
        };
        if (galleryPhotos?.length > 1) {
            const img = galleryPhotos[1];
            if (img !== primaryImage) {
                secondaryImage2 = img;
            }
        }

        // Primary Image
        let primaryImageView = null;
        let primaryImageSource = null;
        if (this.state.primaryImagePreview) {
            primaryImageSource = this.state.primaryImagePreview.croppedImage ? this.state.primaryImagePreview.croppedImage.source : this.state.primaryImagePreview.originalImage.source;
        }else if (primaryImage?.croppedImage?.source || primaryImage?.originalImage?.source) {
            primaryImageSource = primaryImage.croppedImage ? primaryImage.croppedImage.source : primaryImage.originalImage.source;
        }
        if (primaryImageSource) {
            primaryImageView = (
                <div
                    className={`image-block primary photo ${this.state.showPrimaryImageUpload === true ? 'is-active' : '' }`}
                    style={{
                        backgroundImage: `url(${primaryImageSource})`
                    }}>
                    <Button
                        appearance="solid-white"
                        size="sm"
                        onClick={this.editPrimaryImage}
                        tabIndex="0">
                        Edit or Replace Primary Hero Image
                    </Button>
                </div>
            );
        }else{
            primaryImageView = (
                <div className={`image-block primary empty-photo-block ${this.state.showPrimaryImageUpload === true ? 'is-active' : '' }`}>
                    <Button
                        appearance="tertiary"
                        size="sm"
                        onClick={this.uploadPrimaryImage}>
                            Upload Primary Hero Image
                    </Button>
                </div>
            );
        }

        // Secondary Image 1
        let secondaryImage1View = null;
        let image1Source = null;
        if (this.state.secondaryImage1Preview) {
            image1Source = this.state.secondaryImage1Preview.croppedImage ? this.state.secondaryImage1Preview.croppedImage.source : this.state.secondaryImage1Preview.originalImage.source;
        }else if (secondaryImage1?.croppedImage?.source || secondaryImage1?.originalImage?.source) {
            image1Source = secondaryImage1.croppedImage ? secondaryImage1.croppedImage.source : secondaryImage1.originalImage.source;
        }
        if (image1Source) {
            secondaryImage1View = (
                <div
                    className={`image-block secondary photo ${this.state.showSecondary1ImageUpload === true ? 'is-active' : '' }`}
                    style={{
                        backgroundImage: `url(${image1Source})`
                    }}>
                    <Button
                        appearance="solid-white"
                        size="sm"
                        onClick={this.editSecondaryImage1}
                        tabIndex="0">
                        Edit or Replace Secondary Hero Image 1
                    </Button>
                </div>
            );
        }else{
            secondaryImage1View = (
                <div className={`secondary empty-photo-block ${this.state.showSecondary1ImageUpload === true ? 'is-active' : '' }`}>
                    <Button
                        appearance="tertiary"
                        size="sm"
                        onClick={this.uploadSecondaryImage1}>
                            Upload Secondary Hero Image 1
                    </Button>
                </div>
            );
        }

        // Secondary Image 2
        let secondaryImage2View = null;
        let image2Source = null;
        if (this.state.secondaryImage2Preview) {
            image2Source = this.state.secondaryImage2Preview.croppedImage ? this.state.secondaryImage2Preview.croppedImage.source : this.state.secondaryImage2Preview.originalImage.source;
        }else if (secondaryImage2?.croppedImage?.source || secondaryImage2?.originalImage?.source) {
            image2Source = secondaryImage2.croppedImage ? secondaryImage2.croppedImage.source : secondaryImage2.originalImage.source;
        }
        if (image2Source) {
            secondaryImage2View = (
                <div
                    className={`image-block secondary photo ${this.state.showSecondary2ImageUpload === true ? 'is-active' : ''}`}
                    style={{
                        backgroundImage: `url(${image2Source})`
                    }}>
                    <Button
                        appearance="solid-white"
                        size="sm"
                        onClick={this.editSecondaryImage2}
                        tabIndex="0"
                        isDisabled={!galleryPhotos || galleryPhotos?.length < 1}>
                        Edit or Replace Secondary Hero Image 2
                    </Button>
                </div>
            );
        }else{
            secondaryImage2View = (
                <div className={`secondary empty-photo-block ${this.state.showSecondary2ImageUpload === true ? 'is-active' : '' }`}>
                    <Button
                        appearance="tertiary"
                        size="sm"
                        onClick={this.uploadSecondaryImage2}
                        isDisabled={!galleryPhotos || galleryPhotos?.length < 1}>
                            Upload Secondary Hero Image 2
                    </Button>
                </div>
            );
        }

        // Hide the "Above 1240px" tab if this is a gateway page.
        const isGatewayPage = this.props.inventoryType === 'gateway';

        return (
            <div
                className="rec-photo-upload-page-section"
                ref={(ref) => {
                    this._ref = ref
                }}>
                <FlexRow alignItems="center" hasGutters={false} className='rec-photo-upload-page-section-heading'>
                    <FlexCol xs="variable">
                        <Heading headingLevel={2} appearance="h4">
                            Hero Images
                        </Heading>
                    </FlexCol>
                    <FlexCol>
                        <Button
                            className="rec-photo-upload-page-section-helptip-trigger"
                            onClick={this.toggleHelpModal}
                            appearance="subtle"
                            size="sm"
                            iconBeforeElement={<Icons.IconInfo  />}
                            screenReaderTextBefore="Hero Image Example" />
                    </FlexCol>
                    <FlexCol xs={12} md="variable" className="rec-photo-upload-preview-instructions">
                        Preview the layout at different common screen size widths.
                    </FlexCol>
                </FlexRow>

                <FlexRow>
                    <FlexCol>
                        <Tabs appearance="button" id="hero-image-page-size" alignButtonTabs="right" activeIndex={this.state.currentTab} onChange={this.handleChange}>
                            <TabPanel label="Mobile (Below 768px)" className="rec-photo-upload-preview-block">
                                <div className='below-767'>
                                    {primaryImageView}
                                </div>
                            </TabPanel>

                            <TabPanel label={`${isGatewayPage ? "Desktop (Above 768px)" : "Tablet (768px - 1239px)"}`} className={`rec-photo-upload-preview-block ${isGatewayPage ? "rec-photo-upload-gateway-hero" : ""}`}>
                                <div className="between-768-1239">
                                    {primaryImageView}
                                    <div className="secondary-image-block-wrap">
                                        {secondaryImage1View}
                                        {secondaryImage2View}
                                    </div>
                                </div>
                            </TabPanel>

                            <TabPanel label="Desktop (Above 1240px)" isHidden={isGatewayPage === true} className="rec-photo-upload-preview-block">
                                <div className='above-1240'>
                                    {secondaryImage1View}
                                    {primaryImageView}
                                    {secondaryImage2View}
                                </div>
                            </TabPanel>

                        </Tabs>
                    </FlexCol>
                </FlexRow>

                {this.state.showPrimaryImageUpload &&
                    <SinglePhotoManager
                        id={primaryImage.id ?  primaryImage.id : "secondaryImage1"}
                        imageType="hero"
                        imageTypeDisplay="Hero Image"
                        galleryPosition={primaryImage?.position || 0}
                        desiredWidth={1440}
                        desiredHeight={810}
                        showFilesInput={this.state.showFilesInput}
                        originalImage={this.state.primaryImagePreview ? this.state.primaryImagePreview.originalImage : primaryImage.originalImage}
                        croppedImage={this.state.primaryImagePreview ? this.state.primaryImagePreview.croppedImage : primaryImage.croppedImage}
                        altText={primaryImage.altText}
                        caption={primaryImage.caption}
                        credit={primaryImage.credit}
                        uploadManager={this.props.uploadManager}
                        onPublish={this.onPrimaryImagePublish}
                        onUpdate={this.onPrimaryImageUpdate}
                        onDelete={this.onPrimaryImageDelete}
                        onCancel={this.onPrimaryImageCancelEditing}
                        isFreeformCrop={false}
                        showCropOnSelect
                        isHeroImage
                        heroImageName="Primary Hero Image"
                    />
                }

                {this.state.showSecondary1ImageUpload &&
                    <SinglePhotoManager
                        id={secondaryImage1.id ?  secondaryImage1.id : "secondaryImage1"}
                        imageType="gallery"
                        imageTypeDisplay="Gallery Image"
                        position={0}
                        numberOfGalleryItems={gallery.length}
                        galleryPosition={secondaryImage1?.position || 1}
                        showFilesInput={this.state.showFilesInput}
                        originalImage={this.state.secondaryImage1Preview ? this.state.secondaryImage1Preview.originalImage : secondaryImage1.originalImage}
                        croppedImage={this.state.secondaryImage1Preview ? this.state.secondaryImage1Preview.croppedImage : secondaryImage1.croppedImage}
                        altText={secondaryImage1.altText}
                        caption={secondaryImage1.caption}
                        credit={secondaryImage1.credit}
                        uploadManager={this.props.uploadManager}
                        onDelete={this.onSecondaryImage1Delete}
                        onPublish={this.onSecondaryImage1Publish}
                        onUpdate={this.onSecondaryImage1Update}
                        onCancel={this.onSecondaryImage1CancelEditing}
                        getIsAltTextUnique={this.getIsAltTextUnique}
                        isFreeformCrop={false}
                        showCropOnSelect
                        isHeroImage
                        heroImageName="Secondary Hero Image 1"
                    />
                }

                {this.state.showSecondary2ImageUpload &&
                    <SinglePhotoManager
                        id={secondaryImage2.id ?  secondaryImage2.id : "secondaryImage2"}
                        imageType="gallery"
                        imageTypeDisplay="Gallery Image"
                        position={1}
                        numberOfGalleryItems={gallery.length}
                        galleryPosition={secondaryImage2?.position || 2}
                        showFilesInput={this.state.showFilesInput}
                        originalImage={this.state.secondaryImage2Preview ? this.state.secondaryImage2Preview.originalImage : secondaryImage2.originalImage}
                        croppedImage={this.state.secondaryImage2Preview ? this.state.secondaryImage2Preview.croppedImage : secondaryImage2.croppedImage}
                        altText={secondaryImage2.altText}
                        caption={secondaryImage2.caption}
                        credit={secondaryImage2.credit}
                        uploadManager={this.props.uploadManager}
                        onDelete={this.onSecondaryImage2Delete}
                        onPublish={this.onSecondaryImage2Publish}
                        onUpdate={this.onSecondaryImage2Update}
                        onCancel={this.onSecondaryImage2CancelEditing}
                        getIsAltTextUnique={this.getIsAltTextUnique}
                        isFreeformCrop={false}
                        showCropOnSelect
                        isHeroImage
                        heroImageName="Secondary Hero Image 2"
                    />
                }

                <hr />

                <StyledModal
                    heading="Hero Images"
                    size="lg"
                    isOpen={isHelpModalOpen}
                    onRequestClose={this.toggleHelpModal}>
                    <FlexRow className="rec-photo-help-modal-content">
                        <FlexCol sm={5} className="rec-photo-help-modal-left-col mb-2 md-sm-0">

                            {this.state.currentTab === 0 && (
                                <img src={`${process.env.CDN}/img/global/photo-manager/hero-img-example-below-768.jpg`} alt="example hero below 767px" />
                            )}

                            {this.state.currentTab === 1 && (
                                <img src={`${process.env.CDN}/img/global/photo-manager/hero-img-example.jpg`} alt="example hero between 768-1239px" />
                            )}

                            {this.state.currentTab === 2 && (
                                <img src={`${process.env.CDN}/img/global/photo-manager/hero-img-example-above-1240.jpg`} alt="example hero above 1240px" />
                            )}

                        </FlexCol>

                        {this.state.showPrimaryImageUpload && (
                            <div>{this.currentTab}</div>
                        )}
                        <FlexCol sm={7}>
                            <p>
                                The primary hero image is used as the main image for your location’s main page on Recreation.gov You can upload a new hero image by clicking the &quot;Upload Hero Image&quot; button.
                            </p>
                            <p>
                                You can also add two secondary hero images. These smaller-scale images appear alongside the primary hero image in standard and widescreen sizes. You can preview the placement of your hero images by clicking on &quot;Mobile Screen&quot;, &quot;Standard Screen,&quot; and &quot;Widescreen&quot;.
                            </p>
                            <p>
                                If a hero image isn’t provided for your location, a &quot;No Photo Available&quot; label is placed at the top of the page over a generic patterned background image. It is important that each location has a hero image. If there is no hero image available, your location is missing a key visual detail that is used to inform visitor reservation decisions.
                            </p>
                        </FlexCol>
                    </FlexRow>
                    <ModalActions>
                        <Button onClick={this.toggleHelpModal}>
                            Close
                        </Button>
                    </ModalActions>
                </StyledModal>
            </div>
        );
    }
}
